import { useMutation } from "react-query";
import { queryClient } from "services/queries";
import { postRemoveItemShoppingBag } from "../requests/ShoppingBag";
import logger from "components/Logger"
import { useDispatch } from "react-redux";
import { API_SHOPPING_BAG_QUERY_KEY } from "../queries/useQueryShoppingBag";
import { IShoppingBagData } from "../../../types/ShoppingBag";


export function useMutationRemoveItemShoppingBag() {
    return useMutation(postRemoveItemShoppingBag, {
        onMutate: async (deletingItem) => {
            // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
            await queryClient.cancelQueries(API_SHOPPING_BAG_QUERY_KEY)

            // Snapshot the previous value
            const oldShoppingBag = queryClient.getQueryData<IShoppingBagData>(API_SHOPPING_BAG_QUERY_KEY)
            if(oldShoppingBag === undefined) return

            // TUDO ISSO só pra inserir um 'item fake' pra mostrar ele carregando na tela de shopping bag
            const newShoppingBag:IShoppingBagData = {
                ...oldShoppingBag,
                items: oldShoppingBag.items.filter(i => i.id !== deletingItem.item_id)
            }

            // Optimistically update to the new value
            queryClient.setQueryData<IShoppingBagData>(API_SHOPPING_BAG_QUERY_KEY, newShoppingBag)

            // Return a context with the previous and new todo
            return { oldShoppingBag, newShoppingBag }
        },
        onSuccess: async (data) => {
            if(data?.success) {
                await queryClient.cancelQueries(API_SHOPPING_BAG_QUERY_KEY)
                //queryClient.setQueryData<IShoppingBagData>(API_SHOPPING_BAG_QUERY_KEY, data.data)
                // console.log(data)]
                 //console.log(data);
                //dispatch(setShoppingBag(data.data, 'services/api/mutations/useMutationAddItemShoppingBag'));
                //queryClient.invalidateQueries('apiShoppingBag')
                //queryClient.invalidateQueries(API_SHOPPING_BAG_QUERY_KEY)
            } else {
                // console.log(data?.errors)
            }
        },
        onError: (data) => {
            // console.error(data)
        },
        onSettled() {
            queryClient.invalidateQueries(API_SHOPPING_BAG_QUERY_KEY)
        }

    });
}
